import React, { Component } from 'react';
import {Dialog, DialogTitle,DialogContent,DialogContentText,DialogActions,TextField  } from '@material-ui/core';
import Button from '../../../Common/VMButton';
import './ChangeTitleInput.scss';
import i18n from '../../../i18n';

class ChangeTitleInput extends Component {
    enterKey = () => {
        if(window.event.code  === "Enter"){
            this.props.onTitleSubmitButtonClicked() 
        }
        return
    }
    render() {
        return (
            <div onKeyPress = {this.enterKey}>
            <Dialog open={this.props.open} aria-labelledby='new-template-title' onClose ={this.props.onClose}   aria-describedby="new-template-desc">
                <div style={{minWidth : "400px"}}>

               
                <DialogTitle lang={this.props.value} id="new-template-title">{i18n.t("ChangeTitleInput.dialog.title")}</DialogTitle>
                <DialogContent>
                        <TextField fullWidth = {true} lang={this.props.value} placeholder ={`${this.props.video.name}`}  onChange={this.props.onChange}></TextField>
                    <p lang={this.props.value} className={"title-warning"}>{this.props.visibleTitleNull && i18n.t("timeinput.placeholder.input")}</p>
                </DialogContent>
                <DialogActions style={{margin: "0px 20px 10px 20px"}}>
                    <Button style={{marginRight : "10px"}} color='default' width='80px' height='30px' onClick={this.props.onTitleSubmitButtonCancel}>{i18n.t("global.cancel")}</Button>
                    <Button color='dark-gray-v2' width='80px' height='30px' onClick={this.props.onTitleSubmitButtonClicked}>{i18n.t("global.confirm")}</Button>
                </DialogActions>
                </div>
          </Dialog>
          </div>
        );
    }
}

export default ChangeTitleInput;